import { createSelector } from 'reselect'
import { getActiveNoteId } from 'data/ui/selectors'
import { getEntity, getEntityMap, getListState } from 'data'
import Immutable from 'immutable'

export const ALL_NOTES_LIST_NAME = 'allNotes'
export const ALL_ARCHIVED_NOTES_LIST_NAME = 'allArchivedNotes'
export const ALL_TEMPLATE_NOTES_LIST_NAME = 'allTemplateNotes'

export const getNote = (state, noteId) => {
  const transient = state.notes.transient.get(noteId)
  const entity = getEntity(state, 'Note', noteId)
  return transient ? entity.merge({ title: transient.get('title') }) : entity
}

export const getAllTemplateNotesListState = getListState(
  ALL_TEMPLATE_NOTES_LIST_NAME
)

export const getAllTemplateNotes = createSelector(
  state => getAllTemplateNotesListState(state),
  state => getAllNotes(state),
  (listState, allNotes) => {
    return listState.nodes
      .map(noteId => {
        return allNotes.get(noteId)
      })
      .filter(x => x)
  }
)

export const getAllNotes = state => getEntityMap(state, 'Note')

export const getAllBookmarkedNotes = state => {
  const noteIds = state.notes.bookmarkedNoteIds.reduce((notes, id) => {
    const note = getNote(state, id)
    return note && !note.archivedAt ? notes.set(id, note) : notes
  }, Immutable.OrderedMap())
  return noteIds.reverse() // To get the most recent bookmarked notes first
}

export const getActiveNote = state => {
  const activeNoteId = getActiveNoteId(state)
  return getNote(state, activeNoteId)
}

export function recursivelyGetNotePathIds(
  allNotes,
  noteId,
  parentNoteIds = []
) {
  const note = allNotes.get(noteId)
  const parentNoteRef = note && note.get('parentNote')
  if (!parentNoteRef) {
    return parentNoteIds
  }
  const parentNoteId = parentNoteRef.get('id')
  return recursivelyGetNotePathIds(
    allNotes,
    parentNoteId,
    parentNoteIds.concat(parentNoteId)
  )
}

export const getActiveNoteAncestorsIds = createSelector(
  state => getEntityMap(state, 'Note'),
  state => getActiveNoteId(state),
  (allNotes, activeNoteId) => {
    if (!activeNoteId) {
      return []
    }
    return recursivelyGetNotePathIds(allNotes, activeNoteId)
  }
)

export const isLockedForEdition = (state, noteId) => {
  const note = getNote(state, noteId)

  if (!note) {
    return false
  }

  return note.isLocked
}
